import axios from 'axios';

import router from '../../router';

import { apiBaseUrl } from '@/environment/environment';
import { removeClientStore } from '@/app/views/auth/shared/services';
import { CLIENT_API_CREDENTIALS, registerRoutes } from '@/config';

const config = {
  baseURL: apiBaseUrl,
  // timeout: 120000,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
  // accept: application/json, text/plain, */*
};

const httpClient = axios.create(config);

export function setHeader(header) {
  httpClient.defaults.headers.common[header.key] = header.value;
}

export function setResponseType(reponseType) {
  httpClient.defaults.responseType = reponseType;
}

export function removeResponseType() {
  delete httpClient.defaults.responseType;
}

const authInterceptor = config => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.common["Authorization"] = `Bearer ${token}`;
  }

  return config;
}

const loggerInterceptor = config => {
  /** Add loggin here */
  return config;
};

httpClient.interceptors.request.use(authInterceptor);
httpClient.interceptors.request.use(loggerInterceptor);

// httpClient.interceptors.request.use(req => {
//   if (req.defaults.headers.common["Authorization"]) return req;
//   throw ({message:"the token is not available"});
//  },error=>{
//   return Promise.reject(error);
//  }
// );

// httpClient.interceptors.request.use(
//   config => {
//     const token = localStorage.getItem("token");

//     // console.log(router);
//     // console.log(router.options);
//     // console.log(router.history.current);

//     // router.push({
//     //   path: "/login"})

//     if (token ) {  // && router.history.current.meta.auth
//       config.headers.common["Authorization"] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   error => {
//     return Promise.reject(error);
//   }
// );



// httpClient.interceptors.response.use(
//   response => {
//     if (response.status === 200 || response.status === 201) {
//       return Promise.resolve(response);
//     } else {
//       return Promise.reject(response);
//     }
//   },
// )

httpClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    /** Do somethig with error response */

    // return Promise.reject(error);

    if (error.response.status) {
      switch (error.response.status) {
        case 400:

         //do something
          break;

        case 401:

          // console.error('session expired');
          // console.error(router.currentRoute.fullPath);


          // INFO: no eliminar token de APP en las rutas de registro cliente
          if ( !registerRoutes.includes(router.currentRoute.name)) {

            // console.error('removeClientStore');

            localStorage.removeItem("token");
            removeClientStore();

            router.replace({ path: "/login" }).catch(e => console.log(e));

          } else {

            // console.error('client APP Logged');

            if (localStorage.getItem("user_email") ===  CLIENT_API_CREDENTIALS.email &&
                localStorage.getItem("user_name") === CLIENT_API_CREDENTIALS.name) {

              // console.warn('localStorage.getItem("user_name") === CLIENT_API_CREDENTIALS.name');

            }
            //  else {

              // router
              // .replace({
              //   path: "/clientes/personal",
              //   query: {
              //     redirect: router.currentRoute.fullPath,
              //     error: "Registro incorrecto. Completa tus datos personales"
              //   }
              // })
              // .catch(e => console.log(e));

            // }


            // router.push({ path: "/clientes" }).catch(e => console.log(e));

          }

          break;
        case 403:

          // router.replace({
          //   path: "/login",
          //   query: { redirect: router.currentRoute.fullPath }
          // });

           break;
        case 404:
          // TODO: Page not found
          // alert('page not exist');
          break;
        case 502:
         setTimeout(() => {
            // router.replace({
            //   path: "/login",
            //   query: {
            //     redirect: router.currentRoute.fullPath
            //   }
            // });
         }, 1000);
      }
      return Promise.reject(error.response);
    }



  }
);

export { httpClient };

